import qs from "qs";

export class GreetingClient {
  constructor(httpClient, baseURL) {
    this.httpClient = httpClient;
    this.greetingBaseURL = `${baseURL.replace("/api", "")}/greeting`;
    this.baseURL = baseURL;
  }

  postSend(data) {
    const url = `${this.greetingBaseURL}/send`;

    return this.httpClient.request("post", url, { data });
  }

  async getReport(query) {
    const queryString = qs.stringify(query, {
      addQueryPrefix: true
    });

    const url = `${this.baseURL}/conversations/report${queryString}`;

    const response = await this.httpClient.request("get", url, {
      responseType: "blob"
    });

    return response;
  }
}
